import { useState } from "react";
import { Grid } from "@mui/material";
import FormTextField from "../../utils/CustomFields/FormTextField";
import { useNavigate } from "react-router-dom";
import Loader from "../../utils/Loading";
import styles from "./styles.module.css";
import { ROUTES, STORAGE_KEYS } from "../../../const";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import SubscriptionService from "../../../services/SubscriptionService";

function LicenceSetup() {
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  const handleContinue = async () => {
    if (!token.trim()) {
      toast.error("Please enter a valid license token.");
      return;
    }

    setIsLoading(true);

    try {
      const resp = await SubscriptionService.verifyRegistrationKey(token);

      if (resp?.plan) {
        localStorage.setItem(STORAGE_KEYS.REGISTRSATION_KEY, token);
        navigate(ROUTES.LOGIN);
      } else {
        toast.error("Invalid license token. Please try again.");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Loader isOpen={isLoading} />
      <Grid container rowSpacing={5} className={styles.textArea}>
        <Grid item xs={12}>
          <Grid container rowSpacing={1}>
            <Grid item xs={12} display="flex" justifyContent={"center"}>
              <span className={styles.head1}>Setup </span>
              <span className={styles.head2}>Licence</span>
            </Grid>

            <Grid item xs={12} className={styles.text}>
              <span>Enter your license token to activate your subscription and securely access your account</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} display="flex" justifyContent={"center"} style={{ paddingTop: "24px" }}>
          <div className={styles.cardWrapper}>
            <div className={styles.formCard}>
              <div className={styles.formInner}>
                <FormTextField
                  placeholder="Licence Token"
                  fullWidth
                  value={token || ""}
                  onChange={(e) => setToken(e.target.value)}
                  className={styles.tokenInput}
                  inputProps={{ "aria-label": "license token" }}
                />

                <button
                  className={`${styles.continueBtn} ${!token.trim() ? styles.disabled : ""}`}
                  onClick={handleContinue}
                  disabled={!token.trim()}
                >
                  Continue
                </button>

                <div className={styles.backRow}>
                  <span>Back to</span>
                  <Link to={ROUTES.LOGIN} className={styles.backLink}>
                    <span className={styles.loginText}>Login?</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default LicenceSetup;
